import _ from 'lodash';
import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from '../lib/create_model';

const AttributeType = createEnum('DATE', 'PERCENT', 'STRING');
const AttributePresentation = createEnum('VISIBLE', 'EDITABLE', 'HIDDEN');

const AttributeDef = createModel({
  modelName: 'AttributeDef',

  properties: {
    attr: prop(String).isRequired,
    label: String,
    linkTemplate: String,
    presentation: prop(String)
      .oneOf(..._.values(AttributePresentation))
      .default(AttributePresentation.VISIBLE),
    type: prop(String)
      .oneOf(..._.values(AttributeType))
      .default(AttributeType.STRING),
  },
});

export { AttributeType, AttributePresentation };
export default AttributeDef;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/configuration/attribute_def.js